/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'
import type {
    CardsDTO,
    CollectionDTO,
    CollectionTypeDTO,
    DeleteRequestMemoryCollectionsByCollectionUuidParams,
    GetRequestCardsParams,
    GetRequestMemoryCollectionsByCollectionUuidParams,
    GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    HTTPValidationErrorDTO,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Get me page cards from the backend
 * @summary Get Cards
 */
export const getRequestCards = (
    params: GetRequestCardsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<CardsDTO>({ url: `/cards`, method: 'GET', params, signal }, options)
}

export const getGetRequestCardsQueryKey = (params?: GetRequestCardsParams) => {
    return [`/cards`, ...(params ? [params] : [])] as const
}

export const getGetRequestCardsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCardsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestCards>>, TError, TData>>
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestCardsQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestCards>>> = ({ signal }) =>
        getRequestCards(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestCards>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestCards>>>
export type GetRequestCardsQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestCards<
    TData = Awaited<ReturnType<typeof getRequestCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCardsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestCards>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestCards>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestCards>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestCards<
    TData = Awaited<ReturnType<typeof getRequestCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestCards>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestCards>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestCards>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestCards<
    TData = Awaited<ReturnType<typeof getRequestCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCardsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestCards>>, TError, TData>>
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Cards
 */

export function useGetRequestCards<
    TData = Awaited<ReturnType<typeof getRequestCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCardsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequestCards>>, TError, TData>>
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestCardsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Get collection by uuid

 * @summary Get Memory Collection
 */
export const getRequestMemoryCollectionsByCollectionUuid = (
    collectionUuid: string,
    params: GetRequestMemoryCollectionsByCollectionUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<CollectionDTO>(
        {
            url: `/memory_collections/${encodeURIComponent(String(collectionUuid))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestMemoryCollectionsByCollectionUuidQueryKey = (
    collectionUuid?: string,
    params?: GetRequestMemoryCollectionsByCollectionUuidParams,
) => {
    return [`/memory_collections/${collectionUuid}`, ...(params ? [params] : [])] as const
}

export const getGetRequestMemoryCollectionsByCollectionUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestMemoryCollectionsByCollectionUuidQueryKey(collectionUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>
    > = ({ signal }) =>
        getRequestMemoryCollectionsByCollectionUuid(collectionUuid, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!collectionUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestMemoryCollectionsByCollectionUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>
>
export type GetRequestMemoryCollectionsByCollectionUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestMemoryCollectionsByCollectionUuid<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestMemoryCollectionsByCollectionUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestMemoryCollectionsByCollectionUuid<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestMemoryCollectionsByCollectionUuid<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Memory Collection
 */

export function useGetRequestMemoryCollectionsByCollectionUuid<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMemoryCollectionsByCollectionUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestMemoryCollectionsByCollectionUuidQueryOptions(
        collectionUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Delete a collection by uuid

 * @summary Delete Memory Collection By Uuid
 */
export const deleteRequestMemoryCollectionsByCollectionUuid = (
    collectionUuid: string,
    params: DeleteRequestMemoryCollectionsByCollectionUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        {
            url: `/memory_collections/${encodeURIComponent(String(collectionUuid))}`,
            method: 'DELETE',
            params,
        },
        options,
    )
}

export const getDeleteRequestMemoryCollectionsByCollectionUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestMemoryCollectionsByCollectionUuid>>,
        TError,
        { collectionUuid: string; params: DeleteRequestMemoryCollectionsByCollectionUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestMemoryCollectionsByCollectionUuid>>,
    TError,
    { collectionUuid: string; params: DeleteRequestMemoryCollectionsByCollectionUuidParams },
    TContext
> => {
    const mutationKey = ['deleteRequestMemoryCollectionsByCollectionUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestMemoryCollectionsByCollectionUuid>>,
        { collectionUuid: string; params: DeleteRequestMemoryCollectionsByCollectionUuidParams }
    > = (props) => {
        const { collectionUuid, params } = props ?? {}

        return deleteRequestMemoryCollectionsByCollectionUuid(
            collectionUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestMemoryCollectionsByCollectionUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestMemoryCollectionsByCollectionUuid>>
>

export type DeleteRequestMemoryCollectionsByCollectionUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Memory Collection By Uuid
 */
export const useDeleteRequestMemoryCollectionsByCollectionUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestMemoryCollectionsByCollectionUuid>>,
            TError,
            {
                collectionUuid: string
                params: DeleteRequestMemoryCollectionsByCollectionUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestMemoryCollectionsByCollectionUuid>>,
    TError,
    { collectionUuid: string; params: DeleteRequestMemoryCollectionsByCollectionUuidParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestMemoryCollectionsByCollectionUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Memory Collection By Type
 */
export const getRequestMemoryCollectionsCollectionByTypeByCollectionType = (
    collectionType: CollectionTypeDTO,
    params: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<CollectionDTO>(
        {
            url: `/memory_collections/collection_by_type/${encodeURIComponent(String(collectionType))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestMemoryCollectionsCollectionByTypeByCollectionTypeQueryKey = (
    collectionType?: CollectionTypeDTO,
    params?: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
) => {
    return [
        `/memory_collections/collection_by_type/${collectionType}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestMemoryCollectionsCollectionByTypeByCollectionTypeQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionType: CollectionTypeDTO,
    params: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestMemoryCollectionsCollectionByTypeByCollectionTypeQueryKey(
            collectionType,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>
    > = ({ signal }) =>
        getRequestMemoryCollectionsCollectionByTypeByCollectionType(
            collectionType,
            params,
            requestOptions,
            signal,
        )

    return { queryKey, queryFn, enabled: !!collectionType, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>
>
export type GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestMemoryCollectionsCollectionByTypeByCollectionType<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionType: CollectionTypeDTO,
    params: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestMemoryCollectionsCollectionByTypeByCollectionType<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionType: CollectionTypeDTO,
    params: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestMemoryCollectionsCollectionByTypeByCollectionType<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionType: CollectionTypeDTO,
    params: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Memory Collection By Type
 */

export function useGetRequestMemoryCollectionsCollectionByTypeByCollectionType<
    TData = Awaited<ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionType: CollectionTypeDTO,
    params: GetRequestMemoryCollectionsCollectionByTypeByCollectionTypeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestMemoryCollectionsCollectionByTypeByCollectionType>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestMemoryCollectionsCollectionByTypeByCollectionTypeQueryOptions(
        collectionType,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}
